import { cn } from '@/lib/utils.ts'

export const DOT_COLORS = [
  '#FF7B60',
  '#FF993B',
  '#FFBF42',
  '#1DC083',
  '#3AE2D1',
  '#27CBFF',
  '#6096FF',
  '#976CDF',
  '#FF89DE',
  '#18181B33',
  '#09090B',
  '#E4E4E7',
]

// like in tailwind config
export const dotColors = {
  red: '#FF7B60',
  orange: '#FF993B',
  black: '#09090B',
  gray: '#18181B33',
  pink: '#FF89DE',
  green: '#1DC083',
  turquoise: '#27CBFF',
  yellow: '#FFBF42',
  blue: '#6096FF',
  teal: '#3AE2D1',
  purple: '#976CDF',
  white: '#E4E4E7',
}

const DEFAULT_FILL = dotColors.green

type PropsT = {
  fill?: string
  className?: string
}
export const Dot = ({ fill, className }: PropsT) => {
  if (!fill || !DOT_COLORS.includes(fill)) {
    fill = DEFAULT_FILL
  }
  return (
    <svg
      className={cn(`size-5`, className)}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <circle cx="8" cy="8" r="4" fill={fill} />
    </svg>
  )
}
